import axios from "axios";

const Base_Url="https://banglacalender.in/api"


const getPolicyFromData = async (authToken,getvendorId) => {

   
  try {
    const resPolicyData = await axios({
      method: "get",
      url: `${Base_Url}/vendor/forms`,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: {   // ✅ use params instead of data
        status: "all",
        vendor_id: getvendorId,
      },
    });

    // console.log("Res policy data: ", resPolicyData.data);
    return resPolicyData.data||[];
  } catch (error) {
    console.log("Error occurs when Fetching policy data: ", error);
  }
};

const handlePolicyFromSubmittedData = async (policyFromData, authToken,vendorId) => {
  // console.log("authToken", authToken);

  const BASE_URL_DYNAMIC=vendorId?`${Base_Url}/vendor/forms`:`${Base_Url}/forms`;
  

  console.log("vendorId for vendorId Form Submission: ", vendorId);
  


  try {
    const payload = {
      name: policyFromData.name,
      email: policyFromData.email,
      phone: policyFromData.phone,
      date_of_birth: policyFromData.date_of_birth.split("-").reverse().join("-"),
      pan: policyFromData.pan,
      aadhar: policyFromData.aadhar,
      policy_id: policyFromData.policy_Id, // or map to actual policy id
      amount: policyFromData.amount,
      duration_months: policyFromData.duration_months,
      vendor_id: vendorId||"", // keep static or pass dynamically
      nominee:
        policyFromData.nominee === "Yes"
          ? {
              name: policyFromData.nominee_name,
              relation: policyFromData.relation_with_nominee,
              gender:"male",
              aadhar: "789456120265",
            }
          : null,
    };

    const resHandlePolicyFrom = await axios.post(BASE_URL_DYNAMIC, payload, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    console.log("resHandlePolicyFrom: ", resHandlePolicyFrom);

    return resHandlePolicyFrom.data;
  } catch (error) {
    console.error("Error occurs when handling policy form data: ", error.response?.data?.errors );
    throw error.response?.data?.errors;
  }
};



export default handlePolicyFromSubmittedData;

export {
    getPolicyFromData,
}